//#region import libraries
import React from 'react';

// bootstrap
import { Form, Row, Col } from 'react-bootstrap';
//custom component
import { TextLabel } from '_atoms';

// redux
import { useSelector } from 'react-redux'
import { selectUserDb } from '../../../redux/slices/profile/user-profile'

import { Colors } from '_styles';
//#endregion

const DBUserInfo = (props) => {

    const dbUser = useSelector(selectUserDb);

    return (
        <Row>
            <Col xs={2}>
                {/* Margin Space */}
            </Col>
            <Col>
                <TextLabel
                    disabled={true}
                    label={'Assistance'}>{dbUser && dbUser.assistance ? dbUser.assistance : ''}
                </TextLabel>
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'PRM Bio'}</Form.Label>
                <Form.Control
                    disabled={true}
                    style={{}}
                    value={dbUser && dbUser.bio ? dbUser.bio : ''}
                    defaultValue={dbUser && dbUser.bio ? dbUser.bio : ''}
                    as='textarea'
                />
            </Col>
            <Col>
                <TextLabel
                    label={'User ID'}
                    disabled={true}
                >{dbUser && dbUser.firebaseId ? dbUser.firebaseId : ''}</TextLabel>
            </Col>
        </Row>
    );
};

export default DBUserInfo;
